import {browserInitItem} from './browser-init-item'

export const browserInitItems = () => {
  browserInitItem()
}
